import {Inject, Injectable, Optional} from '@angular/core';
import {GestureConfig, HammerInstance, MAT_HAMMER_OPTIONS, MatCommonModule} from '@angular/material/core';

/** Atributo que desliga o Hammer (gestos touch) no elemento. Ex.: <button matTooltip="..." data-sem-gestos>. */
export const ATRIBUTO_SEM_GESTOS = 'data-sem-gestos';

const HAMMER_VAZIO: HammerInstance = {
  on: () => {
  },
  off: () => {
  }
};

/**
 * GestureConfig do Angular Material que permite desligar o HammerJS em elementos específicos.
 *
 * No Material 8 todo matTooltip escuta (longpress) para exibir o tooltip no toque longo em telas touch. Com o
 * HammerJS carregado, cada tooltip cria uma instância completa do Hammer, que também escuta pointermove/pointerup
 * na janela inteira. Em telas com muitos tooltips (ex.: grid de pré-cargas, ~6 por linha) isso deixa a criação
 * das linhas lenta e faz milhares de handlers rodarem a cada movimento do mouse.
 *
 * Elementos marcados com o atributo estático `data-sem-gestos` recebem um Hammer vazio (o gesto nunca dispara).
 * Em todos os outros elementos o comportamento é exatamente o do GestureConfig original.
 * Única diferença nos elementos marcados: em telas touch o tooltip não abre no toque longo; com mouse nada muda.
 *
 * Funciona porque o Angular (View Engine) aplica os atributos estáticos do elemento antes de registrar os listeners.
 * O atributo precisa ser estático no template (não [attr.data-sem-gestos]).
 */
@Injectable()
export class GestureConfigComOptOut extends GestureConfig {
  constructor(
    @Optional() @Inject(MAT_HAMMER_OPTIONS) hammerOptions?: any,
    @Optional() commonModule?: MatCommonModule
  ) {
    super(hammerOptions, commonModule);
  }

  buildHammer(element: HTMLElement): HammerInstance {
    if (element.hasAttribute && element.hasAttribute(ATRIBUTO_SEM_GESTOS)) {
      return HAMMER_VAZIO;
    }
    return super.buildHammer(element);
  }
}
